import {
  JsonApiCurrentUser,
  ProfileType,
} from '../../@types/jsonapi.d';

export function isCompanyAdmin(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.companyAdmin);
  }
  return false;
}

export function isMJGAdmin(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.MJGAdmin);
  }
  return false;
}

export function isModerator(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.moderator);
  }
  return false;
}

export function isSchoolCoach(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.schoolCoach);
  }
  return false;
}

export function isStudent(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.student);
  }
  return false;
}

export function isMentor(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.mentor);
  }
  return false;
}

export function isAmbassador(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.employee);
  }
  return false;
}

export function isVIP(user?: JsonApiCurrentUser): boolean {
  if (Array.isArray(user?.profiles)) {
    return !!user?.profiles.find(({ type }) => type === ProfileType.vip);
  }
  return false;
}

export function isProfessional(user?: JsonApiCurrentUser): boolean {
  return isMentor(user) || isAmbassador(user) || isVIP(user);
}

export function isCompanyAdminButNotAmbassador(user?: JsonApiCurrentUser): boolean {
  return isCompanyAdmin(user) && !isAmbassador(user);
}
